var React = require('react');

function IconOffices (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M472.542 389.133v617.556H0V389.133h472.542zM1000 0v1006.689H527.337V0H1000zM396.498 665.045H275.344v121.322h121.154V665.045zm-199.3 0H75.986v121.322h121.212V665.045zm527.401 0H603.387v121.322h121.212V665.045zm199.351 0H802.796v121.322H923.95V665.045zM396.498 460.988H275.344v121.264h121.154V460.988zm-199.3 0H75.986v121.264h121.212V460.988zm527.401 0H603.387v121.264h121.212V460.988zm199.351 0H802.796v121.264H923.95V460.988zM724.6 267.979H603.386v121.154h121.212V267.98zm199.35 0H802.796v121.154H923.95V267.98zM724.6 74.913H603.386v121.212h121.212V74.913zm199.35 0H802.796v121.212H923.95V74.913z","fill":"currentColor","fillRule":"nonzero"}));
}

IconOffices.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000"};

module.exports = IconOffices;

IconOffices.default = IconOffices;
